import React from 'react';
import {Link} from 'react-router-dom';
import './FullMenu.scss';

// Scanned pages of the printed 8.5x14 menu, exported at 150dpi from
// "MENU 8-5 X 14 - 6-PAGE FINAL DRAFT AUG 12.pdf" (kept out of git, see .gitignore).
// To regenerate:
//   pdftoppm -jpeg -jpegopt quality=82 -r 150 <the.pdf> public/lancers-menu/page
const PAGE_WIDTH = 1275;
const PAGE_HEIGHT = 2100;

const pages = [
  {
    id: 'cover',
    src: '/lancers-menu/page-1.jpg',
    label: 'Cover',
    alt: 'Lancers Diner and Lounge, Burbank, California — printed menu cover.',
  },
  {
    id: 'breakfast',
    src: '/lancers-menu/page-2.jpg',
    label: 'Breakfast',
    alt: 'Breakfast: favorites, eggs, South of the Border, house omelettes, off the griddle, and breakfast sides.',
  },
  {
    id: 'lunch',
    src: '/lancers-menu/page-3.jpg',
    label: 'Luncheon',
    alt: 'Luncheon: homemade soups and chili, deli hot sandwiches, sandwiches, big burgers, and lunch sides.',
  },
  {
    id: 'starters',
    src: '/lancers-menu/page-4.jpg',
    label: 'Starters & Sweets',
    alt: 'Starters and sweets: appetizers, salads, ice cream treats, and pie and cake.',
  },
  {
    id: 'dinner',
    src: '/lancers-menu/page-5.jpg',
    label: 'Dinner',
    alt: 'Dinner: daily specials, dinner plates, South of the Border, Italian dishes, and house favorites.',
  },
  {
    id: 'drinks',
    src: '/lancers-menu/page-6.jpg',
    label: 'Drinks',
    alt: 'Drinks: coffee, tea and juice, beer, wine, wake-up calls, spiked coffees, and cocktails.',
  },
];

export default function FullMenu () {
  return (
    <div className="full-menu-page">
      <h1 className="full-menu-title">Our Menu</h1>

      <p className="full-menu-note">
        These are photos of our printed menu.{' '}
        <Link to="/order">View the online ordering menu</Link> for prices and
        descriptions in text, or to order for pickup or delivery.
      </p>

      <nav className="full-menu-jump" aria-label="menu sections">
        <ul>
          {pages.map((page) => (
            <li key={page.id}>
              <a href={`#menu-page-${page.id}`}>{page.label}</a>
            </li>
          ))}
        </ul>
      </nav>

      <div className="full-menu-pages">
        {pages.map((page, index) => (
          <figure
            key={page.id}
            id={`menu-page-${page.id}`}
            className="full-menu-page-item"
          >
            <img
              src={page.src}
              alt={page.alt}
              width={PAGE_WIDTH}
              height={PAGE_HEIGHT}
              loading={index === 0 ? 'eager' : 'lazy'}
            />
            <figcaption>{page.label}</figcaption>
          </figure>
        ))}
      </div>

      <div className="full-menu-order-link">
        <Link to="/order" className="button">Order Online</Link>
      </div>
    </div>
  )
}
